module.exports = __webpack_public_path__ + "img/logo.8a6105b2.png";